// "compressor_3phase_1.current_l1" and "room_1.humidity >= 85" both describe one sensor.
const parseComponentKey = (key: string) => {
    const sensor = String(key || '').trim().split(/\s+/)[0];
    const separator = sensor.indexOf('.');
    if (separator < 0) {
        return { comp: '', seq: '', field: '' };
    }
    const component = sensor.slice(0, separator);
    const seqMatch = component.match(/_(\d+)$/);
    return {
        comp: (seqMatch ? component.slice(0, seqMatch.index) : component).toLowerCase(),
        seq: seqMatch ? seqMatch[1] : '',
        field: sensor.slice(separator + 1).toLowerCase()
    };
};

// A trigger_pre_req may name the generic comp_type ("compressor_1.current") while the
// values carry the specific one ("compressor_1phase_1.current").
const isSameComponent = (one: string, other: string) =>
    one === other || one.startsWith(`${other}_`) || other.startsWith(`${one}_`);

/** True when a flattened component value is one the alert's trigger_pre_req points at. */
export const raisedTheAlert = (valueKey: string, highlightKeys: Array<string>) => {
    const value = parseComponentKey(valueKey);
    if (!value.field) {
        return false;
    }
    return (highlightKeys || []).some((highlightKey) => {
        const highlight = parseComponentKey(highlightKey);
        return highlight.field === value.field
            && highlight.seq === value.seq
            && isSameComponent(highlight.comp, value.comp);
    });
};

/** The JSON line for a flattened value starts with its quoted key. */
export const keyFromJsonLine = (line: string) => {
    const match = line.match(/^\s*"([^"]+)"\s*:/);
    return match ? match[1] : '';
};